import { SideMenu } from '@/components/SideMenu';
import { Wrapper } from './styles';
import { useSideNav } from '@/hooks/useSideNav';
import { Button, Flex } from '@chakra-ui/react';

export function SideNav() {
  const { open } = useSideNav();
  const initialOverflow = window.document.body.style.overflowX;

  return (
    <>
      <Wrapper
        hidden={false}
        initial={false}
        animate={{ width: open ? 250 : 0 }}
        onAnimationStart={() => (window.document.body.style.overflowX = 'auto')}
        onAnimationEnd={() =>
          (window.document.body.style.overflowX = initialOverflow)
        }
      >
        <Flex mt={1} />
        <SideMenu />
      </Wrapper>
    </>
  );
}
